import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../../app/localization/localization";
import { RootStoreContext } from "../../../app/stores/rootStore";

const ClearScreensButton = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    clearScreenConnectionStatus,
    reloadUserScreens,
    selectedScreens,
    activatedScreens,
  } = rootStore.screensStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const handleClick = async () => {
    await clearScreenConnectionStatus();
    await reloadUserScreens();
  };
  return (
    <>
      <Button
        disabled={
          activatedScreens.length === selectedScreens.length ? true : false
        }
        id={`clearScreen`}
        color=""
        onClick={async () => await handleClick()}
        className="w-100 toolbarButton transparentButton"
      >
        <i
          className="fas fa-slash"
          style={{ position: "absolute", fontSize: "25px"}}

        ></i>
        <i
          className="fas fa-desktop iconToolbarButton"
        ></i>
        <h6 className="textToolbarButton mb-0">{t("toolbar_clean_screens_button")}</h6>
      </Button>
    </>
  );
};

export default observer(ClearScreensButton);
